// import * as Vue from 'vue'
// export default (url) => Vue.defineAsyncComponent(() => import(`@/views${url}`))
export default (url) => () => import(`@/views${url}`)
